class jfPolicyRulesView {
    constructor($filter, $scope, $timeout, XRayUtils, JFrogTableViewOptions, JFrogModal, $state) {
        this.TemplateGenerator = JFrogTableViewOptions.cellTemplateGenerators;
        this.tableViewOptions2 = new JFrogTableViewOptions($scope);
        this.$timeout = $timeout;
        this.$state = $state;
        this.xrayUtils = XRayUtils;
        this.$scope = $scope;
        this.$filter = $filter;
    }

    $onInit() {
        this.policy = {
            rules: this.policyRules,
            type: this.policyType
        }

        console.log("Init", this.policyRules);
        this.createGrid()

    }

    createGrid() {
        this.tableViewOptions2.setId('test-table')
            .setObjectName('Rule/Rules')
            .setColumns(this.getColumns())
            .setRowsPerPage(5)

        this.tableViewOptions2.newEntityCustomText = 'New Rule';


        this.tableViewOptions2.on('row.clicked', (data) => {
        });
        //this.setPriorities(this.rulesGridData);
        this.showGrid = true;
        this.tableViewOptions2.setData(this.policy.rules);
    }

    getColumns() {

        let cols = [
            {
                "header": "Priority",
                "field": "priority",
                'cellTemplate': `<div class="{{row.entity.priority}}">{{row.entity.priority}}</div>`,
                "textAlign": "left",
                "width": "100px",
                'sortable': false,
                "filterable": false
            },
            {
                "header": "Rule Name",
                "field": "name",
                "filterable": true,
                "cellTemplate": `<div disable-tooltip-on-overflow style="display:flex;flex-direction:row"><div style="line-height: 28px;flex-shrink:1" jf-tooltip-on-overflow>{{row.entity.name}}</div></div>`,
                "width": "15%",
                'sortable': false
            },
            {
                "header": "Criteria",
                "field": "info.pkgCount",
                'cellTemplate': `<div ng-if="grid.appScope.jfPolicyRulesView.policy.type == 'security'">  <div ng-if="row.entity.criteria.cvss_range">CVSS score from {{row.entity.criteria.cvss_range.from}} to {{row.entity.criteria.cvss_range.to}}</div>
                                <div ng-if="row.entity.criteria.min_severity">Min Severity : {{grid.appScope.jfPolicyRulesView.getSeverityText(row.entity.criteria.min_severity) | capitalizeFirst}}</div></div>
                                <div ng-if="grid.appScope.jfPolicyRulesView.policy.type == 'license' && row.entity.criteria.allowed_licenses"><strong>{{ row.entity.criteria.allowed_licenses.length}} </strong>Allowed Licenses</div>
                                <div  ng-if="grid.appScope.jfPolicyRulesView.policy.type == 'license' && row.entity.criteria.banned_licenses"> <strong>{{ row.entity.criteria.banned_licenses.length}} </strong>Banned Licenses</div>`,
                "width": "35%",
                'sortable': false,
                "filterable": false
            },
            {
                'header': 'Automatic Actions',
                "field": "update",
                'cellTemplate': `<div class="grid-icons-wrapper" ng-if="grid.appScope.jfPolicyRulesView.policy.type == 'security'"   ><i disable-tooltip-on-overflow class="icon icon-xray-alert" jf-tooltip="Generate Violation"></i></div><div class="grid-icons-wrapper"><i ng-hide="key=='block_download' && !val.active" disable-tooltip-on-overflow class="icon"  ng-repeat="(key,val) in grid.appScope.jfPolicyRulesView.sortObj(row.entity.actions)" ng-class="{'icon-xray-webhook':key=='webhooks' && val.length > 0 ,'icon-envelop':key=='mails','icon-build':key == 'fail_build' && val,'icon-xray-artifactory':key == 'block_download' && val,'icon-xray-alert':key == 'custom_severity',[val.toLowerCase()]:key == 'custom_severity'}" jf-tooltip="{{grid.appScope.jfPolicyRulesView.getSActionText(key,val)}}" ></i></div>`,
                "width": "25%",
                'sortable': false,
                "filterable": false
            },
            {
                'header': 'Actions Compatibility',
                "field": "compatibility",
                'cellTemplate': `<div  > <i class="icon" style="font-size:30px" ng-class="{'icon-xray-monitoring-alert':grid.appScope.jfPolicyRulesView.isIncompitable(row.entity.name),'icon-xray-monitoring-ready':!grid.appScope.jfPolicyRulesView.isIncompitable(row.entity.name)}" jf-tooltip="{{}}"  ></i> <jf-help-tooltip jf-tooltip="{{grid.appScope.jfPolicyRulesView.getCompatibilityTooltip(row.entity.name)}}" style="right: 13px;bottom:5px;position:relative"></jf-help-tooltip></div>`,
                "width": "200px",
                'sortable': false,
                "filterable": false
            }
        ];
        return cols;
    }

    getCompatibilityTooltip(ruleName) {


        if (_.findIndex(this.originPolicy.incompitableRules, {name: ruleName}) == -1) {
            return "Automatic Actions is fully compatible with the current Watch's Resources"
        }

        return `This Rule contains action (<strong>${_.startCase(_.find(this.originPolicy.incompitableRules, {name: ruleName}).banned_targets) }</strong>) which are not fully compatible with Watch's Resources: \n (<strong>${_.find(this.originPolicy.incompitableRules, {name: ruleName}).problematicTargets.join(', ')}</strong>)`
    }

    getIncompatibleText(rules) {
        let textArr = [];
        let plural = '';

        _.each(rules, (val, key) => {
            let tmpTxt = '';
            if (val.banned_targets.indexOf(',') > -1) {
                plural = 's';
            } else {
                plural = '';
            }
            tmpTxt = `Rule <strong>'${val.name}'</strong> contains a <strong>'${val.banned_targets}'</strong> action${plural} which is not compatible with  one of the resources target type (${val.problematicTargets})`;
            textArr.push(tmpTxt);
        });
        return textArr.join('\n');
    }

    isIncompitable(ruleName) {
        return _.findIndex(this.originPolicy.incompitableRules, {name: ruleName}) > -1;
    }

    listableColumn(type, listModel, rowNameModel, displayModel, alwaysShow, testIdPrefix = null, showAsyncData,
                   externalCountModel) {
        let nextId = 1;
        testIdPrefix = testIdPrefix ? testIdPrefix + '-' : '';

        displayModel = displayModel ? `{{${listModel}.length}} <span class="grid-pipe-seperator">|</span> {{${displayModel}}}` : `<span class="grid-list-counter" >{{${externalCountModel} ? ${externalCountModel} : ${listModel}.length}}</span> <span class="grid-pipe-seperator">|</span> {{${listModel}.join(\', \')}}{{${externalCountModel} && ${externalCountModel} > ${listModel}.length ? ',...' : ''}}`;

        let id = `${testIdPrefix}{{row.uid}}_${nextId}`;

        let template = `<div><div ng-if="${listModel}.length"
                                   ng-class="{'always-show': ${showAsyncData} || ${alwaysShow} }"
                                   class="ui-grid-cell-contents no-tooltip" id="${id}">
                                <span jf-tooltip-on-overflow class="gridcell-content-text"> <strong style="display:inline-block;width:130px">${type}:</strong> ${displayModel} | <strong style="width: 200px;display: inline-block;" ng-if="!row.entity.criteria.allow_unknown">Disallow Unknown Licenses</strong>  <strong style="width: 200px;display: inline-block;" ng-if="row.entity.criteria.allow_unknown">Allow Unknown licenses</strong>  </span>
                                 <a class="gridcell-showall" ng-if="!(${showAsyncData}) && (table.options.isOverflowing('${testIdPrefix}'+row.uid+'_'+${nextId}) || ${alwaysShow})" href ng-click="table.options.showAll(${listModel},${rowNameModel},col);$event.stopPropagation()"> (See All)</a>
                                 <a class="gridcell-showall" ng-if="${showAsyncData}" href ng-click="table.options.asyncShowAll(${rowNameModel},col)"> (See All)</a>
                             </div>
                             <div ng-if="!${listModel}.length" class="ui-grid-cell-contents no-tooltip" id="${id}"> <strong style="width: 200px;display: inline-block;" ng-if="!row.entity.criteria.allow_unknown">Disallow Unknown Licenses</strong>  <strong style="width: 200px;display: inline-block;" ng-if="row.entity.criteria.allow_unknown">Allow Unknown licenses</strong> | - </div></div>`;

        nextId++;
        return template;
    }

    setPriorities(rulesArr) {
        _.each(rulesArr, (val, key) => {
            val.priority = key + 1;
            return val;
        });
    }

    getSActionText(key, val) {
        switch (key) {
            case 'mails' :
                let mailsList = "";
                if (val && val.length > 0) {
                    mailsList = val.join(' \n')
                    return `Mails (${val.length}) :\n<span>${mailsList}</span>`;
                }
                return `Mails: \n +  <span>${mailsList} </span>`;
            case 'webhooks' :
                let webhooksList = "";
                if (val && val.length > 0) {
                    webhooksList = val.join(' \n')
                }
                return 'Webhooks: \n' + '<span>' + webhooksList + '</span>';
            case 'custom_severity' :
                let severity = this.$filter('capitalizeFirst')(val);
                return ` <span  ><span style="color:#fff" >Generates ${severity} Violation</span></span>`;

            case 'fail_build' :
                return "Fail Build"
            case 'block_download' :
                let unscanned = "";
                if (val && val.unscanned) {
                    unscanned = '(Includes Block Unscanned Artifacts)'
                }
                return "Block Download " + unscanned;
            default:
                return key
        }
    }

    sortObj(obj, comparator) {
        var keys = _.sortBy(_.keys(obj), (key) => {
            return comparator ? comparator(obj[key], key) : key;
        });

        return _.fromPairs(keys, _.map(keys, (key) => {
            return obj[key];
        }));
    }

    getSeverityText(txt) {
        let convertedTxt = txt;
        if (convertedTxt.toLowerCase() == 'unknown') {
            convertedTxt = 'All Severities'
        }
        return convertedTxt
    }

}

export function jfPolicyRulesView() {

    return {
        restrict: 'E',
        scope: {
            $dismiss: '&',
            $close: '&',
            policyRules: '=',
            originPolicy: '=',
            policyType: '='
        },
        controller: jfPolicyRulesView,
        controllerAs: 'jfPolicyRulesView',
        templateUrl: 'directives/jf_policy_rules_view/jf_policy_rules_view.html',
        bindToController: true
    };
}




// WEBPACK FOOTER //
// ./modules/xray/directives/jf_policy_rules_view/jf_policy_rules_view.js